import * as PropTypes from 'prop-types';

import {ArchiveRecord} from 'archive/ArchiveConstants';

interface NewSchemaFieldSelectorOption {
  name: string;
  archiveRecord?: ArchiveRecord | null;
}

export interface ExistingSchemaFieldSelectorOption extends NewSchemaFieldSelectorOption {
  id: string;
}

export type SchemaFieldSelectorOption = ExistingSchemaFieldSelectorOption;
export type SchemaFieldSelectorOptionForUpdate =
  | ExistingSchemaFieldSelectorOption
  | NewSchemaFieldSelectorOption;

export interface SchemaFieldSelector {
  id: string;
  name: string;
  schemaFieldSelectorOptions: Array<SchemaFieldSelectorOption>;
  // All selector options including archived
  allSchemaFieldSelectorOptions: Array<SchemaFieldSelectorOption>;
  archiveRecord?: ArchiveRecord | null;
}

const ARCHIVE_RECORD_SHAPE = PropTypes.shape({purpose: PropTypes.string.isRequired});
const SCHEMA_FIELD_SELECTOR_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  archiveRecord: ARCHIVE_RECORD_SHAPE,
}).isRequired;

export const SELECTOR_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  schemaFieldSelectorOptions: PropTypes.arrayOf(SCHEMA_FIELD_SELECTOR_SHAPE).isRequired,
  allSchemaFieldSelectorOptions: PropTypes.arrayOf(SCHEMA_FIELD_SELECTOR_SHAPE).isRequired,
  archiveRecord: ARCHIVE_RECORD_SHAPE,
});

export interface SchemaTagSelectorOption {
  id: string;
  text: string;
}

export interface SchemaFieldSelectorOptionToUpdate {
  id: string;
  numLinkedTags: number;
  newName?: string;
  newArchiveRecord: ArchiveRecord | null;
  shouldDelete: boolean;
}
